module.exports = __webpack_public_path__ + "platform/static/media/referDrawer.c3041c4d.svg";